import { InjectionToken, inject } from '@angular/core';

import { StakeConfig } from '@frontend/sports/common/client-config-data-access';
import { UserService } from '@frontend/sports/user/feature';

import { NumpadValidationParams } from './model';
import { validationParamsFactory } from './numpad.module';

export const NUMPAD_VALIDATION_PARAMETERS_TOKEN = new InjectionToken<NumpadValidationParams>('NUMPAD_VALIDATION_PARAMETERS_TOKEN', {
    providedIn: 'root',
    factory: () => {
        const stakeConfig = inject(StakeConfig);
        const userService = inject(UserService);

        return validationParamsFactory(stakeConfig, userService);
    },
});
